import React, { Component } from 'react'
import DatePicker from "react-datepicker";
import { isEmpty } from 'lodash';

import "react-datepicker/dist/react-datepicker.css";
import "./datepicker.scss";

import asyncRoute from '../../../helpers/hoc/asyncRoute';
import Error from '../error';

const Tooltip = asyncRoute(() => import('../../../components/FormElements/ToolTip'));
const InfoButton = asyncRoute(()=> import('../../InfoButton'));

export default class Index extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
  }

  componentDidMount() {
    if (this.myRef && this.myRef.current) {
      this.myRef.current.focus();
    }
  }
  
  render() {
    const { value, minDate, maxDate, onBlur, onChange, setting, submited, touched, error, popperPlacement, isClearable, disabled, sDate, infoIcon = false, onInfoClick=()=>{} } = this.props;
    const { labelLayout = 'col-sm-6', infoStyle, showOptional = true } = setting
    const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
      <div className="input-group" ref={ref} onClick={onClick}>
        <input type="text" disabled={disabled} name={setting.key} placeholder={setting.placeholder} autoComplete="off" className={isEmpty(error) ? "form-control" : "form-control has-error"} defaultValue={value} />
        <div className="input-group-append">
          <span className="input-group-text"><span className="mdi mdi-calendar date-icon"></span></span>
        </div>
      </div>
    ));

    // const CustomInput = React.forwardRef(({ value, onClick, onKeyDown, onChange }, ref) => {
    //   const formattedValue = value instanceof Date ? value.toISOString().substring(0, 10) : value;
    
    //   return (
    //     <div className="input-group" ref={ref} onClick={onClick}>
    //       <input
    //         type="text"
    //         disabled={disabled}
    //         name={setting.key}
    //         placeholder={setting.placeholder}
    //         autoComplete="off"
    //         className={isEmpty(error) ? "form-control" : "form-control has-error"}
    //         value={formattedValue || ""}
    //         onChange={(e) => {
    //           const inputValue = e.target.value;
    //           if (/^\d{4}-\d{2}-\d{2}$/.test(inputValue)) {
    //             onChange({ target: { name: setting.key, value: new Date(inputValue) } });
    //           } else {
    //             onChange({ target: { name: setting.key, value: inputValue } });
    //           }
    //         }}
    //         onKeyDown={(e) => {
    //           console.log("e.key",e.key)
    //           if (e.key === "Enter") {
    //             e.preventDefault();
    //             onBlur({ target: { name: setting.key, value } });
    //           }
    //         }}
    //         tabIndex={0}
    //       />
    //       <div className="input-group-append">
    //         <span className="input-group-text">
    //           <span className="mdi mdi-calendar date-icon"></span>
    //         </span>
    //       </div>
    //     </div>
    //   );
    // });

    // const CustomInput = React.forwardRef(({ value, onClick, onChange }, ref) => {
    //   const formattedValue = value instanceof Date ? value.toISOString().substring(0, 10) : value;
    
    //   return (
    //     <div className="input-group" onClick={onClick}>
    //       <input
    //         ref={ref}
    //         type="text"
    //         name={setting.key}
    //         placeholder={setting.placeholder}
    //         autoComplete="off"
    //         className={isEmpty(error) ? "form-control" : "form-control has-error"}
    //         value={formattedValue || ""}
    //         onChange={onChange}
    //         onKeyDown={(e) => {
    //           if (e.key === "Enter") {
    //             e.preventDefault();
    //             onBlur({ target: { name: setting.key, value } });
    //           } else {
    //             e.stopPropagation();
    //           }
    //         }}
    //         tabIndex={0}
    //       />
    //       <div className="input-group-append">
    //         <span className="input-group-text">
    //           <span className="mdi mdi-calendar date-icon"></span>
    //         </span>
    //       </div>
    //     </div>
    //   );
    // });
    
    
    

    return (
      <div className="form-group row  custom-date-picker">
        {setting.label && <label htmlFor={setting.key} className={`${labelLayout} col-form-label`}>{setting.label}{" "}{(setting.required) ?  <span className='text-danger'>*</span> : (showOptional &&  <><br /><span className="small" style={{ color: "#1925238a" }}>Optional</span></>) }
        <InfoButton 
        infoIcon={infoIcon}
        onInfoClick={onInfoClick}
        infoStyle={infoStyle}
        />
        </label>}
        <div className={setting.displayLayout}>
          <DatePicker
            disabled={disabled}
            selected={value}
            name={setting.key}
            onChange={(date) => {
              onChange({ target: { name: setting.key, value: date } });
              onBlur({ target: { name: setting.key, value: date } })
            }}
            onClickOutside={() => {
              onBlur({ target: { name: setting.key, value: value } })
            }}
            className="form-control"
            minDate={minDate}
            maxDate={maxDate}
            popperPlacement={popperPlacement}
            autoComplete="off"
            isClearable={isClearable}
            placeholderText={setting.placeholder}
            customInput={<CustomInput />}
            startDate={sDate != undefined ? sDate : ""}
            dateFormat="yyyy-MM-dd"
          /> {(submited || touched) && (<Error setting={setting} error={error} />)}
        </div>
        {setting.tooltip && <Tooltip text={setting.tooltip} />}
      </div>
    )
  }
}
// export default  React.forwardRef((props, ref) => <Index
// innerRef={ref} {...props}
// />);